import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  Input
} from "@angular/core";


import { LoadingService } from "@shared/services/loading.service";


@Component({
  selector: "app-spinner",
  templateUrl:"./spinner.component.html",
  styleUrls: ["./spinner.component.scss"]
})
export class SpinnerComponent implements OnInit, OnDestroy {
  @Input() static: boolean = false;
  @Input() show = false;
  constructor(
    public loader: LoadingService
  ) {
    if(!this.static)
    this.loader.loading$.subscribe(show => this.show = show);
  }

  @Output() directionEvent = new EventEmitter<Object>();

  ngOnInit() {
   
  }

  ngOnDestroy() {
   
  }

}
